export default {
    ACCEPTED: 0,
    PENDING: 1,
    REJECTED: 2,
};
